import { render, staticRenderFns } from "./ClusterRole.vue?vue&type=template&id=4037343b&"
import script from "./ClusterRole.vue?vue&type=script&lang=js&"
export * from "./ClusterRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports